"use client"

import { ModalProvider } from "@/components/Modal/ModalContext";
import { ModalsRoot } from "@/components/Modal/ModalRoot";
import { ToastProvider } from "@/contexts/ToastContext";
import { ChildContainerProps } from "@/types/types";
import { ConfirmDialog } from "primereact/confirmdialog";

const Providers = ({ children }: ChildContainerProps) => (
  <ToastProvider>
    <ModalProvider>
      <ModalsRoot />
      <ConfirmDialog />
      {children}
    </ModalProvider>
  </ToastProvider>
)

export { Providers }